import { t } from "i18next";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

import Warning from "@/assets/icons/warning.svg?react";
import { Button } from "@/components/Button";
import { useStore } from "@/hooks/store";
import { API_ROUTES } from "@/interfaces/api";
import { APP_ROUTES } from "@/routes/constants";

import styles from "./styles";
import { SheetModal } from "../index";

export enum ModalType {
  BuyHapi,
  MintScore,
}

export const useWarningModal = () => {
  const [isOpen, setOpen] = useState<boolean>(true);
  const [data, setData] = useState<{
    modalType: ModalType;
    params?: { hapiBalance: string; requiredBalance: string };
  } | null>(null);

  const { user } = useStore((store) => ({
    user: store.user,
  }));
  const navigate = useNavigate();
  const openModal = (modalType: ModalType, params?: { hapiBalance: string; requiredBalance: string }) => {
    params ? setData({ modalType, params }) : setData({ modalType });
    setOpen(true);
  };

  const closeModal = () => {
    setData(null);
    setOpen(false);
  };

  const isBuyHapiModal = data?.modalType === ModalType.BuyHapi;
  const handler = () => {
    if (isBuyHapiModal) {
      window.parent.postMessage(
        {
          navigate: "/swaps?to=1010:d9c2d319cd7e6177336b0a9c93c21cb48d84fb54.factory.bridge.near",
        },
        "*",
      );
    } else {
      navigate(APP_ROUTES.HOME);
      if (!user.totalScore) {
        mutate(`${API_ROUTES.USER}/${user.nearAccount}`);
      }
    }
    closeModal();
  };

  const modal = data ? (
    <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
      <styles.Container>
        <Warning />
        <styles.Title>
          {isBuyHapiModal
            ? t("Modals.WarningModal.BuyHapi", { value: data?.params?.hapiBalance ?? "0" })
            : t("Modals.WarningModal.MintScore")}
        </styles.Title>
        <styles.Body>
          <styles.Description>
            {isBuyHapiModal
              ? t("Modals.WarningModal.BuyHapiDescription", { value: data?.params?.requiredBalance ?? "0" })
              : t("Modals.WarningModal.MintScoreDescription")}
          </styles.Description>
        </styles.Body>
        <styles.Footer>
          <Button name={isBuyHapiModal ? "Buy" : "Mint"} handler={handler} />
        </styles.Footer>
      </styles.Container>
    </SheetModal>
  ) : (
    <></>
  );
  return { isOpen, openModal, closeModal, modal };
};
